import React from 'react';
import moment from 'moment';

import ManagedInput from 'components/form/managed_input';
import { formatDate, formatTime, formatDateTime } from 'helpers/formatters/date_time_formats';

export default class DateTimeSample extends React.Component {
  render() {
    const now = moment().format();

    return (
      <div className="date-time-sample">
        <div className="row row-eq-height">
          <div className="col-sm-2 py-3">
            <h4 className="m0">Display Text</h4>
          </div>
          <div className="col-sm-10 py-3">
            <span className="mr-5">Date: {formatDate(now)}</span>
            <span className="mr-5">Time: {formatTime(now)}</span>
            <span className="mr-5">DateTime: {formatDateTime(now)}</span>
          </div>
        </div>

        <div className="row row-eq-height">
          <div className="col-sm-2 py-3">
            <h4 className="m0">Inputs</h4>
          </div>
          <div className="col-sm-10 py-3">
            <span className="mr-5">
              Date:&nbsp;
              <ManagedInput className="form-control" type="date" value={now} />
            </span>
            <span className="mr-5">
              DateTime:&nbsp;
              <ManagedInput className="form-control" type="datetime" value={now} />
            </span>
          </div>
        </div>
      </div>
    );
  }
}
